var map = {
	"./ActionsModal/Cambio.vue": 799,
	"./ActionsModal/SaveChanges.vue": 800,
	"./ActionsModal/index.vue": 245,
	"./agrocolor.vue": 2044,
	"./araporcei.vue": 2045,
	"./coplaca/ParcelasActionsMultiple.vue": 1116,
	"./coplaca/index.vue": 2046,
	"./default.vue": 2047,
	"./demo.vue": 2048,
	"./sites.vue": 291,
	"./widgets/auditorias.vue": 801,
	"./widgets/dictamenes.vue": 804,
	"./widgets/pacs.vue": 806,
	"./widgets/revisiones.vue": 803,
	"./widgets/solicitudes.vue": 802,
	"./widgets/toma_muestras.vue": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1759;